<template>  
  <div>
  <q-card class="card">
  <q-card-section class="text-h6">
    {{ $t('global.Unit') }}: <span class="text-weight-bold">{{ DeviceName }} </span>
  </q-card-section>
  <div class="content">
    <div class="row">
      <div class="col-3 leftSide">
        <q-input v-model="DevicePhone" :label="$t('global.PhoneNumber')"/>
      </div>
    </div> 
    <div class="row">
      <div class="col-5 leftSide">
        <q-select
          :float-label="$t('global.MaintenanceGroup')"
          v-model="MaintenanceGroupID"
          :options="MaintenanceGroupOptions"
          emit-value map-options
        />
      </div>
    </div> 
    <div class="row ">
      <div class="col-3 q-pa-xs">
        <q-checkbox label="Virtual Odo" v-model="VirtualOdoEnabled" />
      </div>
      <div class="col-2 q-pa-xs">
        <q-input  v-model="VirtualOdo" :label="$t('global.OdoMeter')" />
      </div>
    </div> 
    <br> 
    <div class="row">
      <div class="col-3">
        <q-btn color="primary"  
        :label="$t('global.Save')" 
        @click="updateUnit()" 
        :no-caps="true"
        size="sm"
        />
      </div>
    </div>
    <div class="grid">
      <div class="row">
        <div class="col text-weight-bold">
          {{ $t('global.CommdandsSentToUnit') }}
        </div>
      </div>
      <div class="row">  
        <div class="col">{{ $t('global.Generated') }}</div>
        <div class="col">{{ $t('global.Sent') }}</div>
        <div class="col">{{ $t('global.By') }}</div>
        <div class="col">{{ $t('global.Comment') }}</div>
        <div class="col">{{ $t('global.Command') }}</div>
      </div>
      <hr>
      <div class="row" v-for="Command in Commands" :key="Command.DeviceCommandID">  
        <div class="col">{{dateFormat(Command.CreatedAt)}}</div>
        <div class="col">{{dateFormat(Command.SentAt)}}</div>
        <div class="col">{{Command.Login}}</div>
        <div class="col">{{Command.Comment}}</div>
        <div class="col">{{Command.Command}}</div>
      </div>
      <q-pagination
        v-model="page"
        :max="maxPages"
        :max-pages="10"
        direction-links
        size="sm"
      />
    </div>
    <div>
      <br>
      <p>{{$t('global.SendNewCommand')}}:</p>
      <q-option-group
        v-if="TrackerBrandID == 2"
        type="radio"
        v-model="helpCommand"
        :options="[
          { label: $t('global.Disable'), value: '3,8,0' },
          { label: $t('global.Enable'),  value: '3,9,0' },
        ]"
      />
      <q-option-group
        v-if="TrackerBrandID == 3"
        type="radio"
        v-model="helpCommand"
        :options="[
          { label: $t('global.StartTracking'), value: 'StartTrack' },
          { label: $t('global.EndTracking'),  value: 'StopTrack' },
          { label: $t('global.Speak'),  value: $t('global.SpeakText') },
        ]"
      />
      <div class="row">
        <div class="col-4">
          <q-input v-model="sendCom" :label="$t('global.Command')"/>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <q-input v-model="comment" :label="$t('global.Comment')"/>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col-3">
          <q-btn class="button" size="sm" @click="insertCommand()" :disable="!sendCom" color="primary" :label="$t('global.SendCommand')" />
        </div>
      </div>
    </div>
  </div>
  
</q-card>   
<br><br>

</div>
</template>

<script>
import {eventBus} from '../../main'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'UnitCommandDialog',
  data () {
    return {
      form: {
        SessionId: null,
      },
      DeviceName: null,
      DevicePhone: null,
      MaintenanceGroupDescription: null,
      VirtualOdo: null,
      VirtualOdoEnabled: null,
      page: 1,
      minPages: 1,
      maxPages: 10,
      limitPages: 5,
      Commands: [],
      helpCommand: null,
      sendCom: null,
      comment: null,
      TrackerBrandID: null,
      MaintenanceGroupOptions: [],
      MaintenanceGroupID: null

    }
  },
  props: ['Entity'],
  methods: {
    getUnit(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "GetUnit"
      this.form.DeviceID = this.Entity
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          if(response.status == 200){
              var xxx = this
              this.DeviceName = response.data.DeviceName
              this.DevicePhone = response.data.DevicePhone
              this.MaintenanceGroupID = response.data.MaintenanceGroupID.toString()
              this.VirtualOdo = response.data.VirtualOdo
              this.VirtualOdoEnabled = response.data.VirtualOdoEnabled
              this.TrackerBrandID = response.data.TrackerBrandID
              this.getCommands()
          }
          else{
              this.$q.notify('Something Wrong.')
              this.$store.state.loading = false
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
       this.$store.state.loading = false
        console.log(e);
      })
    },
    getCommands(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "GetDeviceCommands"
      this.form.DeviceID = this.Entity
      this.form.Page = this.page
      this.form.Limit = this.limitPages
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          if(response.status == 200){ 
              this.Commands = response.data.Items
              this.maxPages = response.data.TotalPages
          }
          else{
              this.$q.notify('Something Wrong.')
              this.$store.state.loading = false
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
       this.$store.state.loading = false
        console.log(e);
      })
    },
    dateFormat(val) {
      if(val == null){
        return null
      }
      if (this.$i18n.locale == "de")
        return this.moment(val).format('DD.MM.YYYY HH:mm:ss')
      else
        return this.moment(val).format('MM/DD/YYYY HH:mm:ss')
    },
    insertCommand(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "InsertDeviceCommand"
      this.form.DeviceID = this.Entity
      this.form.Comment = this.comment
      this.form.Command = this.sendCom

      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          if(response.status == 200){
              if(response.data == "OK"){
                  this.$q.notify({ message: this.$t('global.Sent'), type: 'positive'})
                  this.getCommands()
              }
              else{
                this.$q.notify('Something Wrong.')
              }
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
       this.$store.state.loading = false
        console.log(e);
      })    
    },
    updateUnit(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "UpdateUnit"
      this.form.DeviceID = this.Entity
      this.form.DevicePhone = this.DevicePhone
      this.form.MaintenanceGroupID = this.MaintenanceGroupID
      this.form.VirtualOdo = this.VirtualOdo
      this.form.VirtualOdoEnabled = this.VirtualOdoEnabled
      

      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          if(response.status == 200){
              if(response.data == "OK"){
                  this.$q.notify({ type: 'positive', message: this.$t('global.Updated')})
              }
              else{
                this.$q.notify('Something Wrong.')
              }
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
       this.$store.state.loading = false
        console.log(e);
      })    
    },
    loadMaintenaceGroups(){
      this.MaintenanceGroupOptions[0] = {value: '0', label: this.$t('global.NotAssigned')}
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "MaintenanceGroupSelect"
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
            response.data.forEach((maintGroup) => {
                this.MaintenanceGroupOptions.push(maintGroup)
            }) 
            this.getUnit() 
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },   
  },
    
  created () {
    this.loadMaintenaceGroups()
    //this.getUnit()
    
    eventBus.$on('dataLoad', (data) => {
      this.getCommands()
    })
  },
   watch: {
    Entity: function (newValue, oldValue) {
      this.getUnit()
      this.helpCommand = null
      this.sendCom = null
      this.comment = null
    },
    page: function (newValue, oldValue) {
      this.getCommands()
    },
    helpCommand: function (newValue, oldValue) {
      this.sendCom = newValue
    }
   },
  
}

function error(err) {
  console.log(`ERROR(${err.code}): ${err.message}`);
}

</script>

<style scoped>
 .leftSide{
   text-align: left;
 }
 .rightSide{
   font-weight: 700;
 }
 .grid{
    color:#0c0c0c;  
    font-size: 12px;
    padding-right: 10px;
    padding-top: 20px;
 }
 .card{
   width: 680px;
   padding-right: 20px;
   background-color: transparent;
 }
 .content{
   padding: 10px;
   padding-top: 0px;
 }
 
 
</style>
